import { SEPARATOR, QUERY_BASE } from '../config/constants/filter';

const filterQueryMaker = (list) => {
    const string = list.map((([attribute, value]) => `${attribute} ${SEPARATOR.EQUAL} ${value}`)).join(` ${SEPARATOR.AND} `)

    return QUERY_BASE + string;
}

export default filterQueryMaker;
